import type { ProvedorMapa } from "../models/roteirizacaoModel"

export interface MarcadorPedido {
    id: number
    latitude: number
    longitude: number
    cliente: string
    /** Código curto do pedido, exibido como rótulo no ponto do mapa. */
    shortReference: string
    nomeEntregador: string | null
    selecionado: boolean
    /** Cor do marcador: vermelho (não alocado) ou preto (alocado). */
    cor: string
}

export interface MapaRoteirizacaoBaseProps {
    origem: { lat: number; lng: number } | null
    marcadores: MarcadorPedido[]
    onSelecionarPedido: (id: number) => void
}

export interface MapaRoteirizacaoProps extends MapaRoteirizacaoBaseProps {
    provedor: ProvedorMapa
    tokenMapbox: string
}

/** Centro padrão (Brasil) quando não há origem nem marcadores. */
export const CENTRO_PADRAO = { lat: -14.235, lng: -51.9253 }

/**
 * Iniciais do entregador para exibir junto ao número do pedido no mapa:
 * primeira letra do primeiro nome + primeira letra do último nome. Quando o
 * entregador não tem sobrenome, usa as duas primeiras letras do nome. Sempre
 * em maiúsculas; string vazia quando não há nome.
 */
export function iniciaisEntregador(nome: string | null | undefined): string {
    if (!nome) return ""
    const partes = nome.trim().split(/\s+/).filter(Boolean)
    if (partes.length === 0) return ""
    if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase()
    const primeiro = partes[0][0]
    const ultimo = partes[partes.length - 1][0]
    return (primeiro + ultimo).toUpperCase()
}

/**
 * Rótulo do ponto no mapa. Quando o pedido já está roteirizado (tem entregador),
 * mostra as iniciais do entregador na frente do número: "JS #123". Caso contrário,
 * apenas "#123".
 */
export function rotuloMarcador(m: MarcadorPedido): string {
    const iniciais = iniciaisEntregador(m.nomeEntregador)
    return iniciais ? `${iniciais} #${m.shortReference}` : `#${m.shortReference}`
}
